import { Helmet } from 'react-helmet-async';
import { CompetitionEvolutionWithProvider } from 'src/components/visibility';

export default function VisibilityCompetitionEvolution() {
  return (
    <>
      <Helmet>
        <title>Competitors</title>
      </Helmet>

      <CompetitionEvolutionWithProvider />
    </>
  );
}
